export default __webpack_public_path__ + "static/media/producto-20.1c325c14.jpeg";